import React, { useEffect } from 'react';
import { Col, Container, Row } from 'shards-react';
import PageTitle from '../components/common/PageTitle';
import Notification from '../components/common/Notification';
import AddInformation from '../components/manage-information/AddInformation';
import GridInformation from '../components/manage-information/GridInformation';
import ModalEditInformation from '../components/manage-information/ModalEditInformation';
import { useTranslation } from 'react-i18next';
import { RootState, useDispatch, useSelector } from '../redux/store';
import { resetServerMessage, getInformationsForManage } from '../redux/slices/information';
import { getUsers } from '../redux/slices/user';

const ManageInformation = (): React.ReactElement => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { hasError, serverMessage } = useSelector((state: RootState) => state.information);

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  /**
   * 初期データの取得
   */
  useEffect(() => {
    dispatch(getUsers({}));
    dispatch(getInformationsForManage());
  }, []);

  // EVENT HANDLER
  // ================================================================================

  /**
   * クローズボタンを押したとき
   */
  const dismiss = (): void => {
    dispatch(resetServerMessage());
  };

  // VIEW
  // ================================================================================
  return (
    <Container fluid className="main-content-container px-4">
      <Row id="pageTitle" noGutters className="page-header py-4">
        <PageTitle sm="4" title={t('information.login.manage')} subtitle="Manage Login Screen Announce" className="text-sm-left" />
      </Row>

      <Notification theme={hasError ? 'danger' : 'success'} isOpen={serverMessage !== undefined && serverMessage.length > 0} message={serverMessage} dismissCallback={dismiss} />

      <Row className="mb-4">
        <Col md="3" sm="6">
          <AddInformation />
        </Col>
      </Row>

      <GridInformation />

      <ModalEditInformation />
    </Container>
  );
};

export default ManageInformation;
